import * as React from 'react';
import {RouteComponentProps, withRouter} from "react-router";
import {ErrorResponse} from "../api/dtos/dtos";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import EventForm from "./EventForm";
import {ErrorAlert} from "../common/ErrorAlert";
import furoApi from "../api/FuroApi";
import {showSaveSuccessNotification} from "../utils/dialogs";
import {DateRange} from "../common/dtos";
import {dateRangeFromQueryParams, stringFromQueryParams} from "../utils/router-utils";
import {EventDto} from "./dtos";
import {
  AlertController,
  bindAlertController,
  GlobalAlertContextConsumer
} from "../app/alert/GlobalAlertContextProvider";

interface CreateEventPageState {
  error?: ErrorResponse;
  initialDateRange?: DateRange;
  initialSalesUser?: string;
}

class CreateEventPage extends React.Component<RouteComponentProps<{}>, CreateEventPageState> {

  public readonly loadingHandler?: LoadingOverlayHandler;
  public readonly alertController?: AlertController;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {
      initialDateRange: dateRangeFromQueryParams(props),
      initialSalesUser: stringFromQueryParams(props, 'salesUser')
    };
  }

  public render(): React.ReactNode {
    const {initialSalesUser, initialDateRange} = this.state;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <GlobalAlertContextConsumer>
          {(state) => bindAlertController(state.event, this)}
        </GlobalAlertContextConsumer>

        <EventForm
          editable={true}
          initialSalesUser={initialSalesUser}
          initialDateRange={initialDateRange}
          onFormCancel={this.onFormCancel}
          onFormSubmit={this.onFormSubmit}
        />

        <ErrorAlert style={{marginTop: '16px'}} error={this.state.error}/>
      </>
    );
  }

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onFormSubmit = (event: EventDto) => {
    const promise = furoApi.events.create(event.toEvent())
      .then(this.onSaveSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onSaveSuccess = () => {
    showSaveSuccessNotification();
    this.alertController?.refreshAlertCount();
    this.props.history.goBack();
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }
}

export default withRouter(CreateEventPage);


// WEBPACK FOOTER //
// ./src/event-details/CreateEventPage.tsx